"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuDDI = void 0;
var menuModule = require('./MenuDDI.module.scss');
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var Cores_1 = require("../../Cores/Cores");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var listaCodigoInternacionalTelefone_1 = require("../../Inputs/InputTelefone/InputDdi/listaCodigoInternacionalTelefone");
var MenuItemDDI_1 = require("./MenuItemDDI/MenuItemDDI");
var Botao_1 = require("../../Botao/Botao");
var Icone_1 = require("../../Icone/Icone");
var MenuDDI = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'menuDDI' : _b, style = _a.style, itemSelecionado = _a.itemSelecionado, _c = _a.estilo, estilo = _c === void 0 ? 'regular' : _c, tituloCabecalho = _a.tituloCabecalho, _d = _a.ocultarDivider, ocultarDivider = _d === void 0 ? false : _d, _e = _a.posicaoDoMenu, posicaoDoMenu = _e === void 0 ? "below" : _e, _f = _a.altura, altura = _f === void 0 ? '100%' : _f, _g = _a.largura, largura = _g === void 0 ? '100%' : _g, _h = _a.opcoesMenu, opcoesMenu = _h === void 0 ? listaCodigoInternacionalTelefone_1.listaCodigoInternacionalTelefone : _h, _j = _a.quebrarLinhas, quebrarLinhas = _j === void 0 ? true : _j, _k = _a.esconderTextoExtenso, esconderTextoExtenso = _k === void 0 ? false : _k, _l = _a.permitirPesquisa, permitirPesquisa = _l === void 0 ? false : _l, _m = _a.permitirDeselecionar, permitirDeselecionar = _m === void 0 ? false : _m, _o = _a.regraTexto, regraTexto = _o === void 0 ? function (item) { return JSON.stringify(item); } : _o, onSelect = _a.onSelect;
    //#region Variaveis
    var _p = (0, react_1.useState)([]), opcoesDisponiveisMenu = _p[0], setOpcoesDisponiveisMenu = _p[1];
    var _q = (0, react_1.useState)(null), selecionado = _q[0], setSelecionado = _q[1];
    var _r = (0, react_1.useState)(''), pesquisa = _r[0], setPesquisa = _r[1];
    var estiloMenu = estilo === 'error' ? menuModule.error : menuModule.regular;
    var posicaoMenu = menuModule[posicaoDoMenu] || '';
    var classesMenu = "".concat(menuModule.menu, " ").concat(estiloMenu, " ").concat(posicaoMenu);
    var gap = tituloCabecalho || permitirPesquisa ? '8px' : '0';
    //#region Metodos
    var handleOptionClick = function (item) {
        var newSelectedItems;
        if (itemSelecionado === null) {
            setSelecionado(item);
            onSelect && onSelect(item);
        }
        else {
            newSelectedItems = itemSelecionado === item && permitirDeselecionar ? null : item;
            setSelecionado(newSelectedItems);
            onSelect && onSelect(newSelectedItems);
        }
    };
    var filterMenuOptions = function (searchTerm) {
        searchTerm = searchTerm.trim();
        if (globalMu_1.default.isNullOrEmptyOrUndefined(searchTerm)) {
            return;
        }
        var regex = new RegExp(pesquisa, 'i');
        var filteredOptions = opcoesMenu.filter(function (item) {
            var itemText = regraTexto(item).toLowerCase().match(regex);
            if (itemText) {
                return itemText;
            }
            else {
                return;
            }
        });
        setOpcoesDisponiveisMenu(filteredOptions);
    };
    //#region Componentes
    var Cabecalho = (react_1.default.createElement("div", { className: menuModule.menuHeader },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", cor: Cores_1.Cores.TextoDestaque.AzulEscuroMU900, negrito: 700 }, tituloCabecalho)));
    var Divider = (react_1.default.createElement("div", { className: menuModule.menuDivider }));
    var ListaItens = (react_1.default.createElement("div", { className: "".concat(menuModule.menuItemList) }, opcoesDisponiveisMenu.map(function (item, index) {
        return (react_1.default.createElement(MenuItemDDI_1.MenuItemDDI, { key: "".concat(id, "-item-ddi-").concat(index), item: item, quebraDeLinha: quebrarLinhas, esconderTextoExtenso: esconderTextoExtenso, estaSelecionado: globalMu_1.default.isDeepEqual(selecionado, item), styleBandeira: {
                width: '25px',
                height: '25px',
            }, regraTexto: regraTexto, onClick: function () { return handleOptionClick(item); } }));
    })));
    var BarraPesquisa = (react_1.default.createElement("div", { className: menuModule.barraPesquisa },
        react_1.default.createElement("input", { type: "text", placeholder: "Pesquisar", value: pesquisa, className: menuModule.inputPesquisa, autoFocus: true, onChange: function (e) {
                setPesquisa(e.target.value);
            }, onKeyDown: function (e) {
                if (e.key === 'Enter' || e.key === 'NumpadEnter') {
                    filterMenuOptions(pesquisa);
                }
            } }),
        react_1.default.createElement(Botao_1.Botao, { tamanho: "small", tipo: "tipoIconSquare", estilo: "outlined", onClick: function () {
                filterMenuOptions(pesquisa);
            }, style: { padding: '17px' } },
            react_1.default.createElement(Icone_1.Icone, { nome: "search", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }))));
    //#region UseEffects
    (0, react_1.useEffect)(function () {
        setSelecionado(itemSelecionado);
    }, [itemSelecionado]);
    (0, react_1.useEffect)(function () {
        if (globalMu_1.default.isNullOrEmptyOrUndefined(pesquisa)) {
            setOpcoesDisponiveisMenu(opcoesMenu);
        }
    }, [pesquisa]);
    (0, react_1.useEffect)(function () {
        setOpcoesDisponiveisMenu(opcoesMenu);
    }, [opcoesMenu]);
    //#region Render
    return (react_1.default.createElement("div", { className: classesMenu, style: __assign(__assign({}, style), { gap: "".concat(gap), height: altura, width: largura }) },
        tituloCabecalho && Cabecalho,
        tituloCabecalho && !ocultarDivider && Divider,
        permitirPesquisa && BarraPesquisa,
        ListaItens));
};
exports.MenuDDI = MenuDDI;
